"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PURCHASE_ORDER_PAYMENT_TERMS_MAX_LENGTH = exports.PURCHASE_ORDER_PAYMENT_TERMS_MIN_LENGTH = exports.PURCHASE_ORDER_PRICE_MIN_BIGGER_THAN = exports.PURCHASE_ORDER_DESCRIPTION_MAX_LENGTH = exports.PURCHASE_ORDER_DESCRIPTION_MIN_LENGTH = exports.PURCHASE_ORDER_NUMBER_MAX_LENGTH = exports.PURCHASE_ORDER_NUMBER_MIN_LENGTH = void 0;
const consts_1 = require("../../consts");
const validators_1 = require("../../utils/validators");
exports.PURCHASE_ORDER_NUMBER_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.PURCHASE_ORDER_NUMBER_MAX_LENGTH = 36;
exports.PURCHASE_ORDER_DESCRIPTION_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.PURCHASE_ORDER_DESCRIPTION_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
exports.PURCHASE_ORDER_PRICE_MIN_BIGGER_THAN = consts_1.PRICE_MIN_BIGGER_THAN;
exports.PURCHASE_ORDER_PAYMENT_TERMS_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.PURCHASE_ORDER_PAYMENT_TERMS_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
